import { warnAboutMissingStyles } from '@entur/utils';
import * as React from 'react';
import React__default from 'react';
import classNames from 'classnames';
import { LoadingDots } from '@entur/loader';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var _excluded$4 = ["as", "children", "variant", "size", "loading", "className", "disabled", "width", "aria-label"];
var defaultElement$9 = 'button';
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _cx;
  var as = _ref.as,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    loading = _ref.loading,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'auto' : _ref$width,
    ariaLabel = _ref['aria-label'],
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var Element = as || defaultElement$9;
  var childrenArray = React.Children.toArray(children);
  var hasLeadingIcon = childrenArray.length > 1 && typeof childrenArray[0] !== 'string';
  var hasTrailingIcon = childrenArray.length > 1 && typeof childrenArray[childrenArray.length - 1] !== 'string';
  var ariaLabelWhenLoading = childrenArray.filter(function (child) {
    return typeof child === 'string';
  }).join(' ');
  var ariaLabelValue = function ariaLabelValue() {
    if (ariaLabel) return ariaLabel;
    if (loading) return ariaLabelWhenLoading;
    return undefined;
  };
  return React.createElement(Element, _extends({
    className: classNames('eds-button', (_cx = {}, _cx["eds-button--variant-" + variant] = variant, _cx["eds-button--size-" + size] = size, _cx['eds-button--width-fluid'] = width === 'fluid', _cx['eds-button--loading'] = loading, _cx['eds-button--leading-icon'] = hasLeadingIcon, _cx['eds-button--trailing-icon'] = hasTrailingIcon, _cx), className),
    ref: ref,
    "aria-busy": loading,
    disabled: disabled,
    "aria-disabled": disabled,
    "aria-label": ariaLabelValue()
  }, rest), loading ? React.createElement(LoadingDots, {
    className: "eds-button__loading-dots"
  }) : children);
});
var defaultElement$8 = 'button';
var PrimaryButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$8;
  // @ts-expect-error type error due to props not being BaseButtonProps
  return React__default.createElement(Button, _extends({
    as: Element
  }, props, {
    ref: ref,
    variant: "primary"
  }));
});
var defaultElement$7 = 'button';
var SecondaryButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$7;
  // @ts-expect-error type error due to props not being BaseButtonProps
  return React__default.createElement(Button, _extends({
    as: Element
  }, props, {
    ref: ref,
    variant: "secondary"
  }));
});
var defaultElement$6 = 'button';
var SuccessButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$6;
  // @ts-expect-error type error due to props not being BaseButtonProps
  return React__default.createElement(Button, _extends({
    as: Element
  }, props, {
    ref: ref,
    variant: "success"
  }));
});
var defaultElement$5 = 'button';
var NegativeButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$5;
  // @ts-expect-error type error due to props not being BaseButtonProps
  return React__default.createElement(Button, _extends({
    as: Element
  }, props, {
    ref: ref,
    variant: "negative"
  }));
});
var defaultElement$4 = 'button';
/** @deprecated use SecondaryButton size="small" instead */
var TertiaryButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$4;
  return React__default.createElement(Button, _extends({
    as: Element
  }, props, {
    ref: ref,
    variant: "tertiary",
    size: "small"
  }));
});
var _excluded$3 = ["as", "className"];
var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$as = _ref.as,
    Element = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React__default.createElement(Element, _extends({
    className: classNames('eds-button-group', className)
  }, rest));
};
var _excluded$2 = ["className", "children", "size"];
var FloatingButton = function FloatingButton(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React__default.createElement("button", _extends({
    className: classNames('eds-floating-button', {
      'eds-floating-button--extended': React__default.Children.count(children) > 1
    }, {
      'eds-floating-button--small': size === 'small'
    }, className),
    type: "button"
  }, rest), wrapStringsInSpans(children));
};
var wrapStringsInSpans = function wrapStringsInSpans(children) {
  return React__default.Children.map(children, function (child) {
    return typeof child === 'string' ? React__default.createElement("span", null, child) : child;
  });
};
var _excluded$1 = ["as", "children", "className", "disabled", "loading", "variant"];
var defaultElement$3 = 'button';
var SquareButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var Element = as || defaultElement$3;
  return React.createElement(Element, _extends({
    className: classNames('eds-square-button', "eds-square-button--" + variant, {
      'eds-square-button--loading': loading
    }, className),
    "aria-busy": loading,
    disabled: disabled,
    "aria-disabled": disabled,
    ref: ref
  }, rest), React.Children.map(children, function (child) {
    if (typeof child === 'string') {
      return React.createElement("span", {
        className: "eds-square-button__label"
      }, child);
    }
    return React.createElement("span", {
      className: "eds-square-button__button"
    }, loading ? React.createElement(LoadingDots, {
      className: "eds-square-button__loading-dots"
    }) : child);
  }));
});
var defaultElement$2 = 'button';
var SecondarySquareButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$2;
  return (
    // @ts-expect-error type error due to props not being BaseButtonProps
    React__default.createElement(SquareButton, _extends({
      as: Element,
      ref: ref
    }, props, {
      variant: "secondary"
    }))
  );
});
var defaultElement$1 = 'button';
var SuccessSquareButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$1;
  return (
    // @ts-expect-error type error due to props not being BaseButtonProps
    React__default.createElement(SquareButton, _extends({
      as: Element,
      ref: ref
    }, props, {
      variant: "success"
    }))
  );
});
var TertiarySquareButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return React__default.createElement(SquareButton, _extends({
    ref: ref
  }, props, {
    variant: "tertiary"
  }));
});
var _excluded = ["children", "className", "disabled", "size", "as", "loading"];
var defaultElement = 'button';
var IconButton = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    as = _ref.as,
    loading = _ref.loading,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Element = as || defaultElement;
  var IconWithAriaHidden = React__default.Children.map(children, function (child) {
    if (React__default.isValidElement(child)) {
      // @ts-expect-error aria-hidden does, in fact, exist
      return React__default.cloneElement(child, {
        'aria-hidden': true
      });
    }
    return child;
  });
  var iconButtonElement = React__default.createElement(Element, _extends({
    className: classNames('eds-icon-button', className, {
      'eds-icon-button--disabled': disabled
    }, "eds-icon-button--size-" + size),
    disabled: disabled,
    "aria-disabled": disabled,
    "aria-busy": loading,
    ref: ref
  }, rest), loading ? React__default.createElement(LoadingDots, null) : React__default.createElement(React__default.Fragment, null, IconWithAriaHidden));
  if (disabled) {
    return React__default.createElement("div", {
      className: "eds-icon-button--disabled__wrapper"
    }, iconButtonElement);
  }
  return React__default.createElement(React__default.Fragment, null, iconButtonElement);
});
warnAboutMissingStyles('button');
export { Button, ButtonGroup, FloatingButton, IconButton, NegativeButton, PrimaryButton, SecondaryButton, SecondarySquareButton, SuccessButton, SuccessSquareButton, TertiaryButton, TertiarySquareButton };